import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase'; // adjust path as needed
import Slider from 'react-slick';
import '../../css/Home.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from 'react-router-dom';

function Home() {
    const [products, setProducts] = useState([]);
    const navigate = useNavigate();

    const slides = [
        {
            subtitle: "Sex Toys",
            description: "Sex toys for men and women are becoming increasingly popular in Sri Lanka as people of all genders explore their sexuality and seek new ways to enhance their pleasure. From vibrators to masturbators, there is a wide range of toys available to suit different tastes and preferences. Many people find that using a sex toy can provide a more intense and satisfying experience than traditional methods. With discreet shipping and online purchasing options, it’s easier than ever for people in Sri Lanka to discover the benefits of incorporating sex toys into their solo or partnered play. Whether you’re new to the world of sex toys or a seasoned enthusiast, there are plenty of options to choose from that can help you take your sexual pleasure to the next level. Don’t be afraid to explore your desires and discover the amazing world of sex toys for men and women.",
        },
        {
            subtitle: "செக்ஸ் பொம்மைகள்",
            description: "ஆண்கள் மற்றும் பெண்களுக்கான செக்ஸ் பொம்மைகள்இன்று இலங்கையில் ஆண்கள், பெண்கள் என அனைத்து பாலினத்தினரும் தங்களது பாலியல் உணர்வுகளை ஆராய்ந்து, புதிய இன்ப அனுபவங்களைத் தேடுவதால், செக்ஸ் பொம்மைகள் அதிகளவில் பிரபலமாகி வருகின்றன. வைப்ரேட்டர் முதல் மாஸ்டர்பேட்டர் வரை, பல்வேறு விருப்பங்களையும் ருசிகளையும் பூர்த்தி செய்யும் வகையில் பரந்த அளவிலான பொம்மைகள் கிடைக்கின்றன.பலர், பாரம்பரிய முறைகளைவிட செக்ஸ் பொம்மைகளைப் பயன்படுத்துவது அதிக தீவிரமும் திருப்திகரமான அனுபவத்தையும் தருகிறது என்று உணர்கிறார்கள். மறைவு கொண்ட டெலிவரி மற்றும் ஆன்லைன் வாங்கும் வசதியால், இலங்கையிலுள்ள மக்களுக்கு செக்ஸ் பொம்மைகளின் பயன்களை அறிந்து கொள்வது மிகவும் எளிதாகி விட்டது.நீங்கள் செக்ஸ் பொம்மைகள் உலகில் புதியவராக இருந்தாலும், அனுபவமிக்க ஆர்வலராக இருந்தாலும், உங்கள் பாலியல் இன்பத்தை அடுத்த நிலைக்கு கொண்டு செல்லும் நிறைய விருப்பங்கள் உள்ளன. உங்கள் ஆசைகளை ஆராய்வதில் தயங்க வேண்டாம்; ஆண்களுக்கும் பெண்களுக்கும் கிடைக்கும் அற்புதமான செக்ஸ் பொம்மைகள் உலகை கண்டறியுங்கள்.",
        },
        {
            subtitle: "ලිංගික සෙල්ලම් බඩු",
            description: "පිරිමි සහ කාන්තාවන් සඳහා වන ලිංගික සෙල්ලම් බඩු, ශ්‍රී ලංකාව තුළ වඩ වඩාත් ජනප්‍රිය වෙමින් පවතින්නේ, සියලුම ස්ත්‍රී පුරුෂ භාවයන්ට අයත් පුද්ගලයන් තම ලිංගිකත්වය ගවේෂණය කරමින් සහ තම කායික සතුට වැඩි දියුණු කර ගැනීමට නව මාර්ග සොයන බැවිනි. vibrators සිට masturbators දක්වා, විවිධ රුචිකත්වයන්ට සහ මනාපයන්ට ගැලපෙන පරිදි පුළුල් පරාසයක සෙල්ලම් බඩු තිබේ. බොහෝ අය සාම්ප්‍රදායික ක්‍රමවලට වඩා ලිංගික සෙල්ලම් බඩුවක් භාවිතා කිරීමෙන් වඩාත් තීව්‍ර සහ තෘප්තිමත් අත්දැකීමක් ලබා ගත හැකි බව සොයාගෙන ඇත. විචක්ෂණශීලී නැව්ගත කිරීම් සහ මාර්ගගත මිලදී ගැනීමේ විකල්ප සමඟින්, ශ්‍රී ලංකාවේ සිටින පුද්ගලයන්ට තනිව හෝ සහකරුවෙකු සමඟ කෙරෙන ඔවුන්ගේ ක්‍රීඩාවට ලිංගික සෙල්ලම් බඩු ඇතුළත් කිරීමෙන් ලැබෙන ප්‍රතිලාභ සොයා ගැනීම පෙරට වඩා පහසු වී ඇත. ඔබ ලිංගික සෙල්ලම් බඩු ලෝකයට අලුත් කෙනෙක් වුවත්, පළපුරුදු උද්යෝගිමත් කෙනෙක් වුවත්, ඔබේ ලිංගික සතුට ඊළඟ මට්ටමට ගෙන යාමට උපකාර කළ හැකි විකල්ප බොහොමයක් තිබේ. ඔබේ ආශාවන් ගවේෂණය කිරීමට සහ පිරිමි සහ කාන්තාවන් සඳහා වන ලිංගික සෙල්ලම් බඩු වල අපූරු ලෝකය සොයා ගැනීමට බිය නොවන්න.",
        },
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false
    };

    // Fetch products from Firestore
    useEffect(() => {
        const fetchProducts = async () => {
            const productsRef = collection(db, "products");
            const snapshot = await getDocs(productsRef);
            const productList = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setProducts(productList);
        };

        fetchProducts();
    }, []);

    const handleShopNow = (id) => {
        // Navigate to the detail page for the product with the specified id.
        navigate(`/detail/${id}`);
    };

    const shopNow = () => {
        // Navigate to the all products page
        navigate("/all-products");
    };

    return (
        <>
            <div className="hero-container">
                <Slider {...settings}>
                    {slides.map((slide, index) => (
                        <div key={index}>
                            <div className="hero-section">
                                <h3 className="subtitle-script">{slide.subtitle}</h3>
                                <p className="description">{slide.description}</p>
                                <button className="shop-button" onClick={() => shopNow()}>—&nbsp; SHOP NOW &nbsp;—</button>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            {/* Product Section */}
            <div className="product-section">
                <h2 className="product-title">All Products</h2>
                <div className="products-grid">
                    {products.map((item) => (
                        <div className="product-card" key={item.id}>
                            <div className="product-img-container-home">
                                <img src={item.image} alt={item.title} className="product-img-home" />
                            </div>
                            <div className="product-details">
                                <p className="product-name">{item.title}</p>
                                <div className="product-pricing">
                                    {item.discount && item.discount > 0 ? (
                                        <>
                                            <span className="discounted-price">
                                                Rs.{(item.price - (item.price * item.discount / 100)).toLocaleString('en-LK')}
                                            </span>
                                            <span className="original-price">
                                                Rs.{item.price.toLocaleString('en-LK')}
                                            </span>
                                        </>
                                    ) : (
                                        <span className="discounted-price">
                                            Rs.{item.price.toLocaleString('en-LK')}
                                        </span>
                                    )}
                                </div>
                                <button
                                    className="shop-button"
                                    onClick={() => handleShopNow(item.id)}
                                >
                                    Shop Now
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Floating WhatsApp Button */}
            <a
                href="https://wa.me/94773719375"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-float"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="WhatsApp"
                    className="whatsapp-icon"
                />
                <span className="whatsapp-text">Need Help? </span>
            </a>
        </>
    );
}

export default Home;